import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { api } from '../lib/api';
import { Plane, CheckCircle2, XCircle, Loader2 } from 'lucide-react';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    document.title = 'Verify email | FlightDeals.in';
    if (ran.current) return; // guard React 18 StrictMode double-invoke (token is single-use)
    ran.current = true;
    if (!token) { setStatus('error'); setMessage('This verification link is missing its token.'); return; }
    api.verifyEmail(token)
      .then(({ data }) => { setStatus('success'); setMessage(data?.message || 'Your email has been verified.'); })
      .catch((err) => { setStatus('error'); setMessage(err?.response?.data?.detail || 'This verification link is invalid or has expired.'); });
  }, [token]);

  return (
    <Layout>
      <div className="max-w-md mx-auto px-4 py-16 text-center">
        <span className="inline-grid place-items-center h-12 w-12 rounded-2xl bg-accent text-accent-foreground mb-3"><Plane className="h-6 w-6" /></span>
        <div className="rounded-2xl border border-border bg-card p-6 mt-2" data-testid={`verify-${status}`}>
          {status === 'loading' && (<><Loader2 className="h-10 w-10 mx-auto text-accent animate-spin mb-3" /><p className="font-medium">Verifying your email…</p></>)}
          {status === 'success' && (<><CheckCircle2 className="h-10 w-10 mx-auto text-emerald-500 mb-3" /><h1 className="font-display text-xl font-semibold">Email verified</h1><p className="text-sm text-muted-foreground mt-1">{message}</p></>)}
          {status === 'error' && (<><XCircle className="h-10 w-10 mx-auto text-destructive mb-3" /><h1 className="font-display text-xl font-semibold">Verification failed</h1><p className="text-sm text-muted-foreground mt-1">{message}</p></>)}
          <div className="mt-5 flex justify-center gap-3">
            <Link to="/account" className="text-accent text-sm font-medium" data-testid="verify-account-link">Go to my account</Link>
            <Link to="/" className="text-muted-foreground text-sm">Back home</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
